import mapActions from './mapActions';

export default mapActions('notifications', {
    fetchAll_url: () => '/api/notifications',
    update_url: id => `/api/notifications/mark_as_read/${id}`,
    delete_url: id => `/api/notifications/mark_as_read/${id}`,
});
